export default {
    SECRET: 'MySeCrEt',
    PASSWORD: 'Olicar75'
}